import "./TaskPanelTop.css";

import { ClosePanelArrowRightBlueIcon, TrashDark } from "../../../../assets";
import { Button } from "../../../../widget";
import { useTaskPanelContext } from "../../TaskPanelContext";

export const TaskPanelTop = (): JSX.Element => {
  const { handleCloseTaskPanel, setShowDeleteTaskModal, hasFullEditAccess, task } = useTaskPanelContext();

  return (
    <div className="TaskPanelTop">
      <Button
        text="Close panel"
        icon={<ClosePanelArrowRightBlueIcon className="CloseIcon" />}
        variant="secondary"
        onClick={handleCloseTaskPanel}
        minWidth={false}
        hasNoPadding
      />
      {hasFullEditAccess && task && (
        <Button
          text=""
          icon={<TrashDark className="TrashIcon" />}
          variant="secondary"
          onClick={() => setShowDeleteTaskModal(true)}
          minWidth={false}
          hasNoPadding
        />
      )}
    </div>
  );
};
